module.exports = __webpack_public_path__ + "img/home_bbs.651446a9.png";